export default {
  content: {
    iosPromptPart1: "Установите это веб-приложение на свой iPhone:<br /> нажмите ",
    iosPromptPart2: "а затем <em>'Добавить на домашний экран.'</em>",
    bookingStatus: {
      statusNew: {
        label: "В ожидании",
        desc: " Ваш заказ был успешно отправлен и находится на рассмотрении."
      },
      statusAccept: {
        label: "Одобрено",
        desc: " Поздравляем! Ваше бронирование было одобрено.",
        pickupText: "Водитель будет ожидать вас после выхода из терминала",
        pickupTextDeparture: "мы сообщим вам о точном времени сбора %time% около 18:00."
      },
      statusReject: {
        label: "Отклонено",
        desc: " Очень жаль, но нам пришлось отклонить ваш заказ",
        moreInfo: "Для получения дополнительной информации, пожалуйста",
        contact: "свяжитесь с нами"
      },
      statusCanceled: {
        label: "Отменено",
        desc: " Ваш заказ был успешно отменен.",
        moreInfo: "Ваш платеж был возвращен и должен быть зачислен на ваш счет в течение 10 рабочих дней.",
        infoWithoutRefund: 'Вы отменяете менее чем за 8 часов до запланированного рейса. Оплата не будет возвращена.',
      },
      statusAssigned: {
        descDeparture: "готов забрать тебя завтра в",
        descTodayDeparture: "готов забрать тебя завтра в",
        descNormal: "будет ждать вас после выхода из терминала.",
        contactInfo: "Вы можете связаться с ним по номеру телефона",
        desc: "Встретьте своего водителя.",
        label: "Готово!"
      },
      statusCompleted: {
        desc: "Мы были бы очень рады, если бы вы могли",
        review: 'оставить a отзыв',
        tripReview: 'Оставить a отзыв',
        label: "Завершено",
        allDone: " Все готово!",
        thanksForReview: 'Спасибо за отзыв!',
      },
      statusNoShow: {
        moreInfo: "Если вы отменяете бронивароние, водитель будет уведомлен",
        desc: "(<span><strong>%driver%</strong>  ждал вас, но вы не явились.</span>)",
        label: "Неявка"
      },
    },
    layout: {
      header: {
        welcomeMessage: "Рады видеть Вас снова!",
        registerMessage: "Впервые на нашем сайте?",
        registerSecondMessage: "Давайте знакомиться.",
        registerButton: "Регистрация",
        helloAgainTitle: "И снова здравствуй!",
        logIn: "Войти",
        activeBookingCount: "<span>У вас есть </span> %count% предстоящее бронирования"
      },
      landingLayout: {
        title: "Доступно и удобно",
        desc: "<span>Путешествуйте в аэропорт</span> просто!",
        bookNow: "Забронируйте сейчас !",
        questionsTitle: "Вопросы?",
        poweredByStripe: "Powered by Stripe & iZettle®"
      },
      menuMain: {
        home: "Главная",
        booking: "Забронировать",
        howItWorks: "Как мы работаем",
        pricing: "Цены",
        faq: "FAQ",
        contact: "Свяжитесь с нами",
        routeHortenTorp: "Маршрут Хортен - Торп",
        complaint: "Подача жалоб",
      },
      sidebarAndHeader: {
        dashboard: 'Поездки',
        booking: 'Поиск',
        myAccount: 'Профиль',
        help: 'Помощь',
        editReservation: 'Изменить бронирование',
        backToEditTitle: 'Вернуться к изменению бронирования',
        backToHelpTitle: 'Вернуться к Помощь',
        backToDashboardTitle: 'Вернуться к Поездки',
      }
    },
    landing: {
      homepage: {
        mainpage: {
          title: "От двери до двери",
          subtitleFirst: "Аэро трансферы",
          subtitleSecond: "Осло Торп"
        },
        about: {
          headline: {
            title: "Поездки в аэропорт стали проще",
            description: "Ты летишь-мы едем!"
          },
          profits: {
            first: {
              title: "Простое бронирование",
              description: "Сообщите нам, куда вы летите, и закажите трансфер из/до аэропорта. Вас заберут из дома, работы или аэропорта - там, где вам больше подходит. Водитель свяжется с вами за несколько минут до прибытия.",
              footer: "Нужна помощь?",
              linkFaq: {
                preTitle: "Изучите наш раздел",
                title: 'FAQ'
              },
              linkContact: {
                separator: " или ",
                title: "Свяжитесь с нами"
              }
            },
            second: {
              title: "Пунктуальный водитель",
              description: "Наш водитель будет вовремя, чтобы забрать вас. Мы прибудем в аэропорт за 1,5 часа до вылета. Если ваш рейс прибывает с задержкой, наш водитель будет ждать вас.",
              footer: "Проверьте статус и редактируйте свои бронирования.",
              linkTitle: "Создать профиль"
            },
            third: {
              title: "Фиксированная цена",
              description: "Вы выбираете, какой способ оплаты наиболее удобен для вас. Вы можете оплатить ваше бронирование онлайн или наличными / картой прямо у  водителя.  Никаких скрытых затрат, вы всегда знаете, сколько платите.",
              footer: "Сколько я буду платить?",
              linkTitle: "Проверить цены"
            },
          }
        },
        testimonials: {
          title: "Наши счастливые клиенты",
          description: "Путешествуйте с нами и станьте одним из них",
          items: {
            first: {
              author: "Агнес Х.",
              content: "Профессиональный, пунктуальный и приятный водитель. Рекомендую!",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            second: {
              author: "Варфоломей О.",
              content: "За день до запланированного отъезда я получил SMS с информацией в16:16. Почти три часа раньше, чем мне сказали, так плюс к этому. Что касается поездки в аэропорт, все прошло хорошо. Хороший водитель и ноль задержек. Мы были ровно за два часа до запланированного вылета.",
              logoAlt: "Facebook",
              url: "facebook.com"
            },
            third: {
              author: "Мишель С.",
              content: "Хороший, быстрый и надежный сервис.",
              logoAlt: "Google",
              url: "google.com"
            },
            fourth: {
              author: "Мэтью С.",
              content: "Автобус был хорошим. Водитель был профессионалом и связался с нами за несколько минут до посадки. По прибытии в Торп невозможно не заметить автобус в аэропорту. Я рекомендую это как более дешевую альтернативу.",
              logoAlt: "Google",
              url: "google.com"
            }
          },
          footer: {
            title: "Отзыв от"
          }
        }
      },
      howItWorks: {
        title: "Как это работает",
        description: "Путешествуйте за меньшие деньги прямо из дома.",
        list: {
          first: {
            title: "Быстрое бронирование",
            description: "Просто сообщите нам свой рейс, закажите трансфер онлайн или позвоните нам, и мы заберем вас c дома, работы или в аэропорта Осло Торп - там, где вам удобно."
          },
          second: {
            title: "Всегда в курсе",
            description: "Создав учетную запись, вы сможете редактировать и проверять статус своего бронирования. Если у вас нет учетной записи, вы получите SMS с подтверждением за день до выезда. Водитель свяжется с вами за несколько минут до прибытия автобуса."
          },
          third: {
            title: "Безопасный транспорт",
            description: "Будьте уверены, что наш водитель вовремя заберет вас. Если ваш рейс прибывает с задержкой, наш водитель будет ждать вас."
          },
          fourth: {
            title: "Удобная оплата",
            description: "Выберите способ оплаты, который подходит вам больше всего: онлайн, либо у водителя с помощью кредитной карты или наличными."
          }
        }
      },
      hortenTorp: {
        title: "Удобный трансфер Хортен – аэропорт Торп (TRF)",
        intro: "Мы забираем вас прямо у паромного терминала в Хортене и везём напрямую к терминалу аэропорта Сандефьорд Торп. Без пересадок на поезд и без стресса с парковкой.",
        heroButton: "Забронировать трансфер сейчас",
        feature: {
          title: "Прибываете паромом Bastøferga из Мосса?",
          description: "Забудьте о сложном расписании общественного транспорта и переноске тяжёлого багажа на большие расстояния. <strong>Flyo заберёт вас прямо у паромного терминала в Хортене.</strong> Как только вы сойдёте с парома Bastøferga, наш трансфер уже будет готов вас встретить. Это гарантирует бесшовную поездку от Мосса через Хортен прямо к выходу на посадку в аэропорту Торп."
        },
        comparison: {
          title: "Почему стоит выбрать Flyo вместо машины или поезда?",
          subtitle: "Как Flyo экономит ваше время, деньги и силы по сравнению с традиционными способами передвижения на маршруте Хортен – Торп:",
          columns: {
            method: "Способ поездки",
            time: "Время и комфорт",
            cost: "Стоимость и стресс"
          },
          flyo: {
            name: "Трансфер Flyo",
            time: "Прямой трансфер (около 35 минут). Отправление согласовано с расписанием вашего рейса.",
            cost: "Фиксированная низкая цена. Без дорожных сборов и дорогой парковки в аэропорту."
          },
          car: {
            name: "Собственный автомобиль",
            time: "Гибко, но вести машину придётся самому и закладывать время на пробки.",
            cost: "Дорого. Дорожные сборы + парковка в Торп легко превышают 800 крон за неделю."
          },
          train: {
            name: "Поезд / Общественный транспорт",
            time: "Сложно. Нужен автобус/такси до Скоппума, поезд до станции Торп и ещё один трансфер до терминала.",
            cost: "Доступно для одного пассажира, но долго и очень утомительно с багажом."
          }
        },
        steps: {
          title: "Как работает маршрут Хортен – Торп",
          subtitle: "От бронирования до прибытия: просто, предсказуемо и комфортно.",
          first: {
            title: "Бронирование за 2 минуты",
            description: "Выберите дату и время вылета или прилёта в Торп. Укажите удобное место посадки в Хортене (например, паромный терминал)."
          },
          second: {
            title: "Встреча в месте посадки",
            description: "Мы используем постоянные, центральные точки сбора в Хортене. Наш водитель ждёт в назначенном месте и поможет с багажом."
          },
          third: {
            title: "Отдыхайте в пути",
            description: "Наслаждайтесь поездкой в одном из наших комфортных современных автомобилей. Мы едем напрямую по трассе E18 без объездов."
          },
          fourth: {
            title: "Высадка у выхода на посадку",
            description: "Мы высаживаем вас прямо у терминала вылета в Сандефьорд Торп. Вы готовы к регистрации за считанные секунды."
          }
        },
        faq: {
          title: "Часто задаваемые вопросы",
          subtitle: "Всё, что нужно знать о трансфере между Хортеном и аэропортом Сандефьорд Торп.",
          first: {
            question: "Где именно у паромного терминала в Хортене меня заберут?",
            answer: "Наш автомобиль паркуется в специальной зоне посадки и высадки пассажиров сразу у выхода паромного терминала Bastøferga в Хортене. Заблаговременно до отправления вы получите SMS с контактами водителя и номером автомобиля."
          },
          second: {
            question: "Что произойдёт, если мой паром или рейс задержится?",
            answer: "Поскольку мы работаем по предварительным бронированиям, мы отслеживаем данные о прилётах в Торп и дорожной обстановке в реальном времени. При небольших задержках парома мы стараемся максимально подстроить расписание, чтобы вы не остались без трансфера."
          },
          third: {
            question: "Могу ли я заказать посадку с частного адреса в Хортене?",
            answer: "Нет, мы работаем исключительно с постоянными центральными транспортными узлами в Хортене. Это позволяет гарантировать предсказуемый, пунктуальный и эффективный сервис для всех пассажиров."
          }
        },
        bottomCta: {
          title: "Готовы к поездке в Торп без стресса?",
          description: "Забронируйте место уже сегодня для более комфортного и предсказуемого начала путешествия.",
          button: "Узнать цену и забронировать"
        }
      },
      complaint: {
        title: "Жалоба на трансфер или поездку на такси",
        introFirst: "Flyo AS стремится к тому, чтобы каждый клиент чувствовал себя безопасно и комфортно. Если во время поездки что-то пошло не так – будь то цена, опоздание, выбранный маршрут, поведение водителя или иные обстоятельства – пожалуйста, воспользуйтесь формой жалобы ниже.",
        introSecond: "Мы рассматриваем все жалобы по мере поступления. Вы получите письменное подтверждение о регистрации обращения, а окончательный ответ мы стремимся предоставить в течение <strong>10 рабочих дней</strong>.",
        form: {
          contact: {
            title: "1. Контактные данные",
            name: {
              label: "Имя и фамилия",
              placeholder: "Иван Иванов"
            },
            email: {
              label: "Адрес электронной почты",
              placeholder: "ivan@primer.no"
            },
            phone: {
              label: "Номер телефона",
              placeholder: "+47 000 00 000"
            }
          },
          trip: {
            title: "2. Сведения о поездке",
            datetime: {
              label: "Дата и время поездки"
            },
            license: {
              label: "Номер лицензии или регистрационный номер автомобиля",
              placeholder: "Напр. Лицензия 1234 / AB 12345"
            },
            pickup: {
              label: "Адрес подачи / Откуда",
              placeholder: "Адрес или аэропорт"
            },
            dropoff: {
              label: "Адрес назначения / Куда",
              placeholder: "Адрес"
            }
          },
          details: {
            title: "3. Чего касается жалоба?",
            category: {
              label: "Категория жалобы",
              empty: "-- Выберите категорию --",
              price: "Цена / Тариф / Расчёт стоимости",
              delay: "Опоздание / Автомобиль не подан",
              driver: "Поведение водителя / Обслуживание",
              route: "Выбор маршрута",
              vehicle: "Состояние автомобиля / Чистота",
              other: "Другое"
            },
            description: {
              label: "Опишите произошедшее как можно подробнее",
              placeholder: "Опишите, что произошло, согласованную цену, применённый тариф и т. д."
            },
            attachments: {
              label: "Документы / Квитанция",
              description: "Любые вложения (квитанцию, выписку по счёту, подтверждение цены) отправьте по электронной почте напрямую на адрес",
              descriptionEnd: "вместе с вашим номером обращения."
            }
          },
          submit: "Отправить жалобу",
          sending: "Отправка..."
        },
        success: {
          title: "Спасибо – ваша жалоба зарегистрирована",
          registered: "Мы получили ваше обращение, и оно зарегистрировано.",
          referenceLabel: "Ваш номер обращения:",
          keepIt: "Сохраните этот номер. Вы получите письменное подтверждение по электронной почте, а окончательный ответ мы предоставим в течение 10 рабочих дней.",
          attachments: "Нужно отправить документы (квитанцию, выписку по счёту, подтверждение цены)? Отправьте их по электронной почте на адрес",
          attachmentsEnd: "указав номер обращения выше."
        },
        appeal: {
          title: "Независимый орган по рассмотрению жалоб (Дальнейшее обжалование)",
          description: "Если вы направили жалобу в Flyo AS и не согласны с нашим решением либо не получили ответ в разумный срок, согласно норвежскому законодательству о профессиональных перевозках вы вправе передать дело в <strong>Норвежское управление по защите прав потребителей (Forbrukertilsynet)</strong> для независимого посредничества. Подробнее на сайте"
        },
        legal: {
          licenceHolder: "Владелец центральной лицензии",
          email: "E-mail для жалоб:",
          compliance: "Соответствует требованиям закона о профессиональных перевозках § 9."
        }
      },
      faq: {
        title: "FAQ",
        description: "Вот список наших наиболее распространенных вопросов  ",
        generalTitle: "Основное",
        paymentTitle: "Оплата",
        accountTitle: "Профиль",
        generalQuestions:
          [
            {
              title: 'Как забронировать трансфер из/до аэропорта?',
              paragraph: 'Вы можете забронировать трансфер из/до аэропорта, используя нашу форму заказа или позвонив нам по телефону +47 96 70 11 03. Сообщите нам, каким рейсом вы собираетесь и где забрать вас, чтобы сделать заказ.'
            },
            {
              title: 'Где я могу найти вас в аэропорту?',
              paragraph: 'Найти водителя в аэропорту легко. Водитель будет ждать вас возле зала прибытия с синей табличкой PKS Oslo. Подойдите к нему, и он проведет вас к микроавтобусу. <br /><br />Внимание: Не забудьте включить телефон после приземления, поскольку водитель может попытаться с вами связаться!'
            },
            {
              title: 'Предлагаете ли вы трансфер до аэропорта Гардермуэн?',
              paragraph: 'Мы не предлагаем совместный трансфер в аэропорт Осло Гардермоен. <br /><br /> Если вы группа из 5 и более пассажиров, мы можем предложить вам частный трансфер. Чтобы заказать частный трансфер, пожалуйста, свяжитесь с нами по адресу <a href="mailto:info@pksoslo.com">info@pksoslo.com</a>.'
            },
            {
              title: 'Я не могу найти свой рейс.',
              paragraph: 'Если ваш рейс не отображается в форме бронирования, это означает, что мы не ездим на этот рейс. Тем не менее, вы можете попытаться найти другой рейс примерно в то же время. Мы будем в аэропорту примерно за 1,5 часа до вылета.'
            },
            {
              title: 'Во сколько за мной приедет автобус?',
              paragraph: 'У нас нет фиксированного расписания, так как наша сервис работает по принципу от двери до двери. Маршрут составляется за 24 часа до поездки, и вы получаете SMS-сообщение за день до вашего отправления около 18.00 с деталями о времени приезда микроавтобуса. <br /><br />Если предложенное время вам не подходит - не беспокойтесь. Вы всегда можете отменить заказ бесплатно. Если вы заплатили картой, оплата будет возвращена в течение 10 рабочих дней.'
            },
            {
              title: 'Какие рейсы вы обслуживаете?',
              paragraph: 'Вы можете ознакомиться со всеми рейсами, которые мы обслуживаем, в нашем приложении. Если вы не нашли нужный рейс, то вы можете попробовать найти другой рейс примерно в то же время.'
            },
            {
              title: 'Могу ли я изменить бронивароние на другую дату?',
              paragraph: 'Если вы хотите изменить дату вашего трансфера, вы можете отменить существующее бронирование и создать новое. Если оплата была произведена картой, вы получите автоматическое возмещение, при отмене рейса за 8 часов до полета.'
            },
            {
              title: 'Есть ли у вас детские кресла безопастности?',
              paragraph: 'Да. При бронировании через наше приложение вы можете выбрать, какое кресло вам нужно. Если вы заказываете трансфер по телефону, наш представитель подберет для вас подходящее кресло.'
            }
          ]
        ,
        paymentQuestions:
          [
            {
              title: 'Могу ли я заплатить кредитной картой?',
              paragraph: 'Да. Вы платите с помощью Visa и Mastercard через наше приложение или непосредственно водителю.'
            },
            {
              title: 'Могу ли я заплатить наличными?',
              paragraph: 'Да. Мы принимаем оплату наличными в норвежских кронах (NOK).'
            },
            {
              title: 'Могу ли я получить деньги обратно?',
              paragraph: 'Если вы отмените поездку за 8 часов до полета, мы вернем вам полную сумму. Это может занять до 10 рабочих дней, прежде чем деньги вернутся на ваш счет.'
            },
          ],
        accountQuestions:
          [
            {
              title: 'Как мне создать профиль?',
              paragraph: 'Вы можете создать профиль, используя нашу страницу регистрации. Вам нужно будет подтвердить свой номер телефона,чтобы активировать профиль.'
            },
            {
              title: 'Могу ли я редактировать свое бронирование?',
              paragraph: 'Вы можете свободно редактировать свое бронирование до 18.00 за один день до полета. Вы можете изменить количество пассажиров, подобрать адрес или детское кресло безопасности.'
            },
            {
              title: 'Как я могу отменить свое бронивароние?',
              paragraph: 'Вы можете отменить бронирование, войдя в свою учетную запись, перейдя в панель инструментов и нажав кнопку "Отмена" на своем трансфере. <br /><br />Если у вас нет учетной записи, вы можете отменить свой трансфер, позвонив нам по телефону +47 96 70 11 03, и один из наших представителей отменит бронирование для вас.'
            },
            {
              title: 'Я забыл свой пароль.',
              paragraph: 'Вы можете создать новый пароль, используя форму «Я забыл свой пароль». Вы получите SMS код на зарегистрированный номер телефона, и затем сможете приступить к созданию нового пароля.'
            },
            {
              title: 'У меня поменяолся номер телефона.',
              paragraph: 'Вы можете изменить свой номер телефона на странице «Профиль.'
            },
          ]
      },
      contact: {
        title: "Свяжитесь с нами",
        description: "Обратитесь к нам, и мы с радостью ответим на ваши вопросы.",
        desc: {
          title: "Связаться!",
          content: "Нам бы хотелось услышать ваше мнение!",
          paragraphs: {
            first: {
              title: "Наш офис работает каждый день",
              desc: "с 08:00 до 21:00"
            },
            second: {
              title: "Мы здесь, чтобы помочь.",
              //              desc: "We’re here to help"
            },
            third: {
              title: "Бронирования",
              desc: "Вы можете заказать трансфер из аэропорта Осло Торп, используя наше приложение или связавшись с нами по телефону."
            },
            fourth: {
              title: "Служба поддержки",
              desc: "Если у вас возникли какие-либо вопросы относительно нашего сервиса, просто свяжитесь с нами, и мы с радостью ответим на них!"
            }
          }
        },
        form: {
          title: "Свяжитесь с нами",
          inputs: {
            name: {
              label: "ФИО / компания",
              placeholder: "Ваше имя и фамилия"
            },
            email: {
              label: "email",
              placeholder: "Ваш email"
            },
            message: {
              label: "ваше сообщение",
              placeholder: "Сообщение..."
            },
            sendButton: "Отправить",
            sendingButton: 'Отправка...'
          }
        }
      },
      pricing: {
        title: "Цены  за трансфера до либо из аэропорта",
        desc: "Получите лучшую цену на аэротрансфер Осло Торп",
        adults: "взрослые",
        kids: "дети*",
        teenagers: 'Teenagers (13-17)',
        students: 'Students',
        seniors: 'Seniors (67+)',
        info: "* Вы можете купить билеты со скидкой для детей до 12 лет.",
        doorToDoor: {
          title: "Трансфер От двери до двери Осло Саннефьорд Торп",
          column: "От двери до двери",
        },
        busStop: {
          title: "Автобусная остановка Трансфер Осло Сандефьорд Торп",
          column: "автобусная остановка",
        }
      },
      termsAndConditions: {
        title: "Положения и условия.",
        desc: "Правила и положения, которые регулируют поездку с PKS Oslo.",
        general: {
          title: "Основные правила",
          list: [
            { content: "Оператором трансфера до аэропорта является Flyo AS, расположенная по адресу: Bekkenstenveien 53B, Oslo, именуемая в дальнейшем «Перевозчик»." },
            { content: "Настоящие условия определяют правила продажи билетов, перевозки пассажиров и багажа, перевозимых Flyo AS." },
            { content: "Документ, который разрешает перевроз, называется «Подтверждение SMS», «Подтверждение по электронной почте» или «Квитанция», именуемое в дальнейшем «Билет»." },
            { content: "Бронирование с Flyo AS означает принятие «Условий»" }
          ]
        },
        booking: {
          title: "Условия бронирования",
          list: [
            { content: "Бронирование для трансфера до аэропорта может быть сделано с помощью приложения бронирования или позвонив в службу поддержки. Бронирование подтверждается email с подтверждением или SMS." },
            { content: "Нет необходимости распечатывать подтверждение по электронной почте. Водитель будет проинформирован обо всех пассажирах, и ему потребуется только имя и / или номер телефона." },
            { content: "Данные клиента не передаются и не продаются третьим сторонам, а все данные клиента хранятся в соответствии с норвежским законодательством." },
            { content: "Flyo AS несет ответственность за эффективность и качество продаваемых вам услуг." },
            {
              content: "Flyo AS несет ответственность за следующее:",
              list: [
                { content: "операции с кредитными картами осуществляемыми через этот сайт." },
                { content: "информирование, когда водитель будет в согласованном месте за один день до отъезда." },
                { content: "информирование о любых существенных изменениях в бронировании." },
              ]
            },
            { content: "Бронирование становится обязательным, когда оно подтверждается по телефону или в письменной форме Flyo AS. Онлайн-бронирование становится обязательным после получения email с подтверждением." },
            { content: "Чтобы отменить или изменить бронирование, пожалуйста, свяжитесь с PKS Oslo по электронной почте: <a href='mailto:info@pksoslo.com'>info@pksoslo.com</a>.Это также можно сделать вручную через наше приложение для бронирования." },
            { content: "Отмена может быть сделана до 8 часов до запланированного рейса с полным возмещением. Возврат не будет произведен, если отмена была сделана менее чем за 8 часов до вашего запланированного рейса." },
            { content: "Смена бронирования на другую дату бесплатна, если она сделана более чем за 8 часов до отправления по расписанию." },
            { content: "Изменить кол-во пассажиров, место сбора и кресла безопасности можно до 18.00 за один день до вылета и бесплатно." },
            { content: "Цены указаны в норвежских кронах (NOK). Все цены указаны с учетом НДС." },
          ]
        },
        carrier: {
          title: "Перевозчик",
          list: [
            { content: "Перевозчик не несет ответственности за задержки и их дальнейшие последствия, вызванные административными факторами (например, полицейские проверки) или другими факторами, не зависящими от Перевозчика (например, технические проблемы, погодные условия, пробки на дорогах)." },
            { content: "Перевозчик будет стремиться перевезти пассажира и багаж в течение разумного времени в соответствии с планом поездки, но по независящим от него причинам он не может этого гарантировать." },
            { content: "Перевозчик оставляет за собой право пользоваться услугами стыковки во время поездки в силу логистических соображений или в целях безопасности пассажиров." },
            { content: "Пассажиры, которые не могут совершить поездку по вине Перевозчика, имеют право на возврат суммы, эквивалентной неиспользованному билету." },
            { content: "Бронирование для микроавтобуса осуществляется путем размещения заказа по телефону или через форму заявки на бронирование на <a href='http://www.pksoslo.com'>www.pksoslo.com</a>. Бронирование подтверждается в момент получения подтверждения по email." },
            {
              content: "Перевозчик имеет право не допускать пассажиров в автобусе или отказывать в дальнейшей перевозке без возмещения расходов, понесенных Пассажиром, когда пассажир:",
              list: [
                { content: "не соответствует правилам настоящих условий," },
                { content: "находится под влиянием алкоголя или наркотиков" },
                {
                  content: `находится в состоянии или ведет себя таким образом, что может отрицательно повлиять на безопасность или комфорт попутчиков.
                  <br>Правовые последствия таких ситуаций несет Пассажир.`
                }
              ]
            },
            { content: "Не разрешается употреблять алкогольные напитки, наркотики или курить." },
            { content: "Разрешено перевозить определенных животных только после предварительного уведомления Перевозчика. Перевозимое животное должно быть надлежащим образом закреплено, находиться в клетке и располагаться на сиденье рядом с пассажиром. Перевозка животных должна быть осуществлена, не мешая другим пассажирам во время поездки." },
            { content: "Стоимость перевозки, налоги, сборы и платежи за услуги Flyo AS не подлежат возврату в случае, если пассажир не явился в согласованное место встречи." },
          ]
        },
        passengers: {
          title: "Пассажиры",
          list: [
            { content: "Пассажиры должны прибыть в назначенное место в назначенный час. Перевозчик не обязан ждать пассажиров, не соблюдающих это положение." },
            { content: "Пассажиры обязаны соблюдать полицейские правила во время поездки." },
            { content: "Пассажиры несут ответственность за любой ущерб, причиненный Перевозчику (в частности, за повреждение в автобусе) и другим пассажирам, на общих основаниях, предусмотренных Гражданским кодексом." },
            { content: "Пассажир обязан использовать ремни безопасности во время путешествия." },
            { content: " Дети в возрасте до 12 лет, рост которых не превышает 150 см, перевозимые в автобусе, должны использовать кресла безопасности или другое оборудование для перевозки детей, соответствующее весу и росту ребенка. Ребенок должен оставаться на протяжении всей поездки в кресле безопасности. Пассажир должен уведомить Перевозчика о том, какие кресла безопасности необходимо взять при оформлении бронирования." },
            { content: "Перевозчик не несет ответственности за несовершеннолетних, путешествующих без законного опекуна." },
            { content: "Предметы, оставленные в автобусе, перевозчиком не возмещаются." }
          ]
        }
      },
      privacyPolicy: {
        title: "Privacy Policy",
        introduction: {
          title: "Introduction",
          list: [
            { content: "<strong>Flyo AS</strong> (“Carrier”) is committed to ensuring that you trust us and how we process your personal information. In this privacy statement, we therefore explain why we collect information about you, how we use this information, and how we take account of your privacy." },
            { content: 'Personal information is information and assessments that can be linked to an identifiable individual. This can be, for example, names and contact information, purchase history or interest information.' },
            { content: "Use of personal data must comply with the Personal Data Act. We, as the controller, will ensure that we use your personal information in accordance with the law." }
          ]
        },
        whatPersonalInformation: {
          title: "What personal information do we have about you?",
          list: [
            { content: "Depending on what information you provide to us, how you use our services, and what permissions you provide to us, we have the following information about you:" },
            { content: '<strong>Information about you:</strong> Information you provide when you create a user account or order tickets, such as name, address, telephone number and email address.' },
            { content: "<strong>Purchase information:</strong> Information we get when you buy tickets from us, such as what you bought, card number and payment method (eg Visa). If you have a user account with us you will get an overview of your previous purchases in your user account." },
            { content: "<strong>Communication:</strong> Information you give us when you contact our customer center, such as emails sent between us." },
            { content: "<strong>Website Usage Information:</strong> Information we get when you use our website and app, such as what kind of device you have (eg mobile or PC), IP address, which pages you visit and what features you use there." },
            { content: "<strong>Profiling Information:</strong> Information and assumptions we automatically create based on the other information (mentioned above) we have about you, such as your preferences and interests and what demographic groups you belong to, unless you have contradicted this." },
          ]
        },
        whatWeUsePersonalInformationFor: {
          title: "What we use personal information for",
          list: [
            { content: "We use your personal information for the following purposes:" },
            { content: '<strong>Website and App:</strong> We use the information to customize our website and app to the technical equipment you use.' },
            { content: "<strong>Execute ticket bookings:</strong> We use the information to complete your ticket purchase, including: to send you the tickets, receive payment and save your purchase history." },
            { content: "<strong>Creating a user account:</strong> We use information if you create a user account, eg. to provide you with username and password, to store your contact information and payment information, and to view your purchase history." },
            { content: "<strong>Customer Service:</strong> We store information that you provide and receive if you contact us to provide service and manage your customer relationship." },
            { content: "<strong>Statistics:</strong> We compile statistics and map market trends to improve and further develop our products and services. As far as possible, we do this with anonymous information, without our knowledge that the information is specifically related to you." },
            { content: "<strong>Marketing:</strong> We use your contact information (eg phone number and email address) to send you recommendations and information about our performances. We may use profiling information to make the recommendations and information most relevant to you, unless you have contradicted this. If you wish, we will also send you recommendations and information about our partners' performances." },
            { content: "The legal basis for Objectives 1, 4 and 5 is our legitimate interest in providing, developing and marketing our services." },
            { content: "The legal basis for purposes 2, 3 and 4 is to fulfill our contract with you." },
            { content: "The legal basis for purpose 5 may also be your consent, if you have given us this. It may be necessary to send you marketing if you no longer have a user account with us, or if we send you marketing about our partners' performances." },
          ]
        },
        whoWeSharePersonalInformationWith: {
          title: "Who we share personal information with",
          list: [
            { content: "We share personal information with companies that provide technical and administrative services to us, such as IT providers. We have agreements with these to ensure your privacy." },
            { content: "We may disclose information in individual cases, for example to public authorities, on suspicion of a criminal offense." },
            { content: "If you consent, we may share your personal information with our affiliates as described in your consent. We use IT suppliers inside the EEA." },
            { content: "We can also share anonymous information with partners for, among other things. market analysis and service development." },
          ]
        },
        howLongWeStorePersonalInformation: {
          title: "How long we store personal information",
          list: [
            { content: "We store information about you only as long as it is necessary to achieve the purpose for which it was obtained, or if we are required to store the information. The information will be deleted or anonymized when it is no longer necessary for the purpose. Below is an overview of how long we store your information:" },
            { content: "<strong>Information about you:</strong> If you have a user account with us, you can contact us and we will delete the information we have about you." },
            { content: "<strong>Purchase information:</strong> If you have a user account with us, we will store your purchase history. We store transactions and payment information for 5 years in accordance with the Accounting Act." },
            { content: "<strong>Website Usage Information:</strong> We store information about your use of our website for up to 6 months." },
            { content: "<strong>Partner Information:</strong> We store any affiliate information as long as you have an active user account with us or as long as you consent. We will delete the information if you cancel your user account." },
            { content: "<strong>Communication:</strong> We store communication with our customers for three years, unless we need to store it longer, e.g. in connection with complaints or claims." },
            { content: "<strong>Profiling information:</strong> If you have a user account with us, we will delete the information when you terminate the user account or user account. We will delete the information earlier if you oppose being profiled." },
          ]
        },
        yourRights: {
          title: "Your rights",
          list: [
            { content: "You have the right to ask us to:" },
            {
              list: [
                { content: "Provide you with additional information on how we process your personal information." },
                { content: "Provide you with a copy of personal information about you." },
                { content: "Update your personal information." },
                { content: "Delete information that we no longer have grounds to store." },
                { content: "Restrict or stop the processing of your information." },
                { content: "Oppose automatic individual decisions, including profiling." },
                { content: "Provide you with information that you have provided to us in a structured, commonly used and machine-readable format or, where technically possible, ask us to transfer these to another company." },
                { content: "Withdraw any consent you have given us." },
              ]
            },
            { content: "Please be aware that there are limitations to these rights. Feel free to contact us for more information on this." },
            { content: "If you believe that we process personal data in violation of the Personal Data Act, you have the right to appeal to the Data Inspectorate. Before you do this, we would like you to contact us so that we can answer your questions or resolve any misunderstandings." },
          ]
        },
        cookies: {
          title: "Cookies",
          list: [
            { content: "We use cookies on our website to ensure website functionality, analyze web traffic and see which sites on our site you have visited." },
          ]
        },
        changesToThePrivacyStatement: {
          title: "Changes to the Privacy Statement",
          list: [
            { content: "We may update the Privacy Statement from time to time. You will be notified of significant changes. You will always find the latest version of our privacy statement on the website / app." },
          ]
        },
        contactInformation: {
          title: "Contact information",
          list: [
            { content: "If you want to get in touch with us, you can use the following contact information:" },
          ],
          address: [
            { content: 'Email address: <a href="mailto:info@pksoslo.com" itemProp="email">info@pksoslo.com</a>' },
            { content: 'Address: <span itemProp="streetAddress">Bekkenstenveien 53B</span>,<span itemProp="postalCode">0976</span> <span itemProp="addressLocality">Oslo</span>' },
          ]
        },
      },
    },
    notifications: {
      default: {
        success: "Успех"
      },
      contact: {
        error: 'Ошибка',
        cannotBeSent: 'Ваш email не может быть отправлен. Пожалуйста, повторите позже.',
        success: 'Сообщение отправлено!',
        successMessage: 'Мы ответим как можно скорее.'
      },
      complaint: {
        error: 'Ошибка',
        cannotBeSent: 'Жалобу не удалось отправить. Пожалуйста, повторите позже.',
        requiredFields: 'Пожалуйста, заполните все обязательные поля.',
        invalidForm: 'Не удалось обработать форму. Проверьте данные и попробуйте снова.',
        invalidData: 'Часть данных не была принята. Проверьте поля, отмеченные ниже.',
        sendFailed: 'Жалобу не удалось отправить из-за технической ошибки. Попробуйте ещё раз через некоторое время или отправьте обращение по адресу support@flyo.no.',
        success: 'Жалоба отправлена!',
        successMessage: 'Вы получите письменное подтверждение по электронной почте и окончательный ответ в течение 10 рабочих дней.'
      },
      reviews: {
        error: 'Ошибка',
        noComment: 'Пожалуйста, введите комментарий',
        success: 'Отзыв сохранен. Спасибо!'
      },
      settings: {
        success: "Сохранено",
        error: "Oops! Невозможно сохранить. Обновите страницу и попробуйте снова."
      },
      invoices: {
        successMessage: "Информация была сохранена.",
        errorTitle: "Ошибка"
      },
      cards: {
        success: "Карта была добавлена.",
        error: "Ошибка"
      },
      cardItems: {
        success: "Карта была удалена.",
        error: "Ошибка",
        errorMessage: "Ошибка при удалении карты."
      },
      addressItem: {
        success: "Адрес был удален.",
        error: "Ошибка",
        errorMessage: "Ошибка при удалении адреса."
      },
      addressComponent: {
        noResults: "No results",
        warning: {
          title: "Внимание!",
          addressInvalid: "Адрес недействителен.",
          addressInDatabase: "Адрес уже сохранен."
        }
      },
      facebook: {
        error: "Ошибка"
      },
      google: {
        error: "Ошибка"
      },
      loginPage: {
        error: "Ошибка"
      },
      loginForm: {
        success: "Вы вошли в систему.",
        error: "Ошибка"
      },
      bookingStep4: {
        error: "Ошибка"
      },
      phoneSmsVerification: {
        success: "Номер телефона был изменен.",
        error: "Ошибка",
        errorMessage: "Enter whole code."
      },
      phoneNumberVerification: {
        success: "Account has been created and you are logged in.",
        error: "Ошибка",
        invalidMessage: "Введите весь код"
      },
      profileResetPassword: {
        success: "Пароль был изменен.",
        error: "Ошибка"
      },
      mapPlaces: {
        success: {
          addressInDatabase: "Адрес уже сохранен.",
        },
        warning:
        {
          title: "Внимание!",
          addressSaved: "Адрес сохранен."
        },
        error: "Ошибка",
        errorMessage: "Ошибка при сохранении адреса",
      },
      reservationEdit: {
        error: "Ошибка",
        errorSubmit: "Ошибка!",
        warning: {
          title: "Внимание!",
          message: "Бронирование не было изменено."
        }
      },
      suplementSummary: {
        success: "Изменения в вашем бронировании были сохранены.",
        error: "Ошибка"
      },
      notificationButtons: {
        cancelSuccess: "Бронирование было отменено.",
        error: "Ошибка",
      }
    },
    supplementSummary: {
      paySupl: "Оплатить"
    },
    reservationEdit: {
      address: "Адрес",
      editAddress: "Изменить адрес",
      passengers: "Пассажиры",
      adults: "Взрослые",
      kids: "Дети",
      editPassengers: "Редактировать кол-во пассажиров",
      oldPrice: "Старая цена",
      changePrice: "Разница в цене",
      newPrice: "Новая цена",
      payWithCard: "Вы выбрали оплату картой",
      payDriver: "Вы решили заплатить водителю. Вам не нужно платить сейчас.",
      changeDetails: "Изменить детали бронирования",
      changeNothing: "Я не хочу ничего менять",
      reservationEditPassengers: {
        title: "Пассажиры",
        desc: "Сменились? Обновите количество пассажиров.",
        adults: "Взрослые",
        kids: "Дети",
        kidsSafetyTitle: "Сиденье безопасности",
        tripMessage: "Вы путешествуете с детьми.",
        carSeatsMessage: "Какой тип сидений безопасности вам нужен?",
      }
    },
    form: {
      inputPhoneNumber: "номер телефона",
      changePhoneNumber: "Изменить номер телефона",
      changePassword: "Изменить пароль",
      changePhoneAndPassword: "Изменить номер телефона и пароль",
      changePhoneDescriptionFirst: "Новый номер телефона необходимо подтвердить еще раз",
      changePhoneDescriptionSecond: "Мы вышлем вам проверочный код в SMS.",
      changePhoneSuccessMessage: "Номер телефона был успешно изменен."
    },
    errors: {
      passengerCount: "Введите правильное количество пассажиров.",
      childrenSeats: 'Выберите cиденье безопасности для детей.',
      card: {
        cardNumber: 'Неверный номер карты',
        cardCvc: 'Неверный CVC',
        date: 'Неверная дата',
        datePast: 'Дата не должна быть в прошлом'
      },
      contact: {
        email: 'Неверный email',
        name: 'Неверное имя',
        message: 'Неверное сообщение',
      },
      complaint: {
        name: 'Укажите имя и фамилию',
        email: 'Укажите адрес электронной почты',
        emailInvalid: 'Неверный адрес электронной почты',
        phone: 'Укажите номер телефона',
        phoneInvalid: 'Неверный номер телефона',
        datetime: 'Выберите дату и время поездки',
        license: 'Неверный номер лицензии или регистрационный номер',
        pickup: 'Укажите адрес подачи',
        dropoff: 'Укажите адрес назначения',
        category: 'Выберите категорию жалобы',
        description: 'Опишите произошедшее',
        descriptionTooShort: 'Описание должно содержать не менее 20 символов',
      },
      auth: {
        loginPage: {
          passwordBlank: 'введите пароль'
        },
        loginForm: {
          passwordBlank: 'введите пароль'
        },
        newPassswordAndCode: {
          codeFull: "Введите весь код.",
          codeEmpty: 'Введите код'
        },
        emailForm: {
          emailEmpty: "Требуется адрес электронной почты",
          emailInvalid: "Неверный адрес электронной почты",
          requestError: "Произошла ошибка. Пожалуйста, попробуйте еще раз."
        },
        customerBasicValidation: {
          nameToShort: "Имя должно быть не короче 3 символов",
          nameToLong: "Имя слишком длинное.",
          emailInvalid: "Неверный Email ",
          passwordToShort5chars: "Пароль  должен быть не меннее 5 символов",
          passwordToLong: "Слишком длинный пароль",
        },
        customerAddressValidation: {
          latEmpty: "Lat cannot be empty",
          lngEmpty: "Lng cannot be empty",
          streetEmpty: "Введите название улицы",
          postCodeEmpty: "Введите индекс",
          typeEmpty: "Тип не может быть пустым"
        },
        customerPhoneValidation: {
          exactlyLength: "телефонный номер должен состоять из %size% цифр",
          minNumbersPre: "Minimum",
          minNumbersPost: "цифры",
          phoneToLong: "Номер телефона слишком длинный",
          countryCodeEmpty: "Отсутствует код страны"
        },
        registrationFormStep1: {
          emailBusy: "Email уже используется"
        }
      }
    },
    auth: {
      loginPage: {
        title: "Привет! Рады видеть вас снова!",
        subtitle: "Продолжить с",
        authSeparator: "или",
        passwordLabel: "пароль",
        forgotPassword: "Забыли пароль?",
        logIn: "Войти",
        accountInfo: "У вас еще нет профиля?",
        createAccount: "Создать",
      },
      newPassswordAndCode: {
        title: 'Сброс пароля',
        codeTitle: 'Мы отправили вам 4-значный код подтверждения',
        codeSentTo: 'на',
        newPasswordLabel: "новый пароль",
        backToEmail: "Вернуться к email",
        changePasswordButton: "Изменить пароль"
      },
      emailForm: {
        title: "Сброс пароля",
        description: "Введите адрес электронной почты, и мы отправим вам код подтверждения",
        emailLabel: "Адрес электронной почты",
        remember: "Я помню! ",
        goBack: "Вернуться",
        resetPasswordButton: "Сброс пароля",
        successMessage: "Пароль успешно изменен"
      },
      registrationForm: {
        title: 'Продолжить с',
        or: 'или ',
        signUpEmail: 'Зарегистрируйтесь при помощи email',
        haveAccount: 'Уже есть профиль?',
        logIn: 'Войти'
      },
      registrationFormStep1: {
        header: 'Приветствуем!',
        labels: {
          fullname: "Имя и фамилия",
          email: "email",
          password: "пароль"
        },
        terms: {
          first: "Продолжая, вы соглашаетесь с нашими",
          second: "Условиями использования",
          and: "и",
          third: "Политикой Конфиденциальности"
        },
        haveAccount: 'Уже есть профиль?',
        logIn: 'Войти'
      },
      registrationFormStep2: {
        linkTitle: "Изменить персональную информацию",
        title: "Почти готово",
        description: "Пожалуйста, убедитесь что номер телефона введен правильно.",
        descriptionSms: "Мы вышлем вам код подтверждения в SMS."
      },
      registrationFormStep3: {
        headerLinkTitle: "Изменить email",
        headerTitle: "введите код подтверждения",
        headerDescription: "Мы отправили вам 4-значный код подтверждения на %email%",
        wrongQuestion: "Неправильный email?",
        change: "Изменить",
        changeTitle: "Изменить email",
        receiveCodeQuestion: "Не получили код?",
        sendAgain: "Отправь еще раз",
        separator: "или",
        skipTitle: "Пропустить",
        skip: "пропустить создание профиль",
        done: "Готово"
      }
    },
    userData: {
      backToAddress: "Вернуться к выбору адреса",
      backToPersonalData: "Вернуться к Персональным данным",
      personalData: "Персональные данные",
      loginForm: {
        accountInfo: "Нет профиля?",
        register: "Зарегистрироваться",
        passwordLabel: "пароль"
      },
      registerForm: {
        accountInfo: "Уже есть профиль?",
        logIn: " Войти",
        labels: {
          fullname: "Имя и фамилия (латиницей)",
          email: "email",
          password: "пароль"
        },
        createAccount: "Создать профиль?",
      },
      changePhoneForm: {
        sendCodeInfo: "Мы отправили вам 4-значный код подтверждения на %phone_label% %phone_number%",
        backToPhone: "Вернуться к номеру телефона",
        done: "Готово"
      }
    },
    addressItem: {
      deleteTitle: 'Удалить адрес',
      deleteQuestion: 'Вы уверены, что хотите удалить этот адрес?',
      confirmButton: 'Да',
      rejectButton: 'Нет, оставить',
      deletePlaceTitle: 'Удалить место'
    },
    account: {
      editProfileTitle: 'Изменить профиль',
      menu: {
        myTrips: 'Мои поездки',
        cards: 'Мои карты',
        places: 'Мои места',
        invoices: 'Счет-фактуры',
        settings: 'Настройки'
      },
      card: {
        deleteCard: 'Удалить карту',
        deleteCardMessage: 'Вы уверены, что хотите удалить эту кредитную карту?',
        title: 'Мои карты',
        stripeTitle: 'Безопасные платежи по Stripe',
        addNewCardTitle: 'Добавить новую карту',
        cardNumberPlaceholder: 'Номер карты',
        cardDatePlaceholder: 'MM / ГГ',
        cardCvcPlaceholder: 'CVC',
        addCardButton: 'Добавить карту',

        removeBtnConfirm: 'Да',
        removeBtnCancel: 'Нет, оставить',
        chooseCard: 'выбрать карту',
        emptyCardsList: 'У вас нет сохраненных карт.',
        addNewCardButton: 'Добавить новую карту',

        addNewOne: 'добавить новую ',
        saveCard: 'Сохранить карту',
        invoiceInfo: 'Информация о счет-фактуре',
      },
      places: {
        title: 'Места',
        myPlaces: 'Мои места',
        list: {
          favPlacesEmpty: 'У вас нет сохраненных мест.',
          addNewAddress: 'Добавить новый адрес'
        }
      },
      invoices: {
        invoiceInfo: 'Информация для счет-фактуры',
        invoiceSave: "Сохранить",
        form: {
          companyNameLabel: 'Название компании',
          addressLabel: 'Адрес',
          taxNumberLabel: 'Идентификационный номер налогоплательщика',
          checkboxInfo: 'Высылать счет за каждое бронирование',
        },
      },
      settings: {
        title: 'Настройки',
        notifications: 'Уведомления',
        language: 'Язык',
        logout: 'Выйти',
        langs: {
          en: 'English',
          no: 'Norsk',
          pl: 'Polski',
          ru: 'Русский'
        }
      }
    },
    login: {
      title: 'Панель входа',
      footer: 'footer'
    },
    sessions: {
      login: {
        title: 'Форма входа',
        email: 'Введите e-mail',
        password: 'Введите пароль'
      }
    },
    dashboard: {
      myTrips: "Мои поездки",
      filterByDate: 'Выберите дату',
      getInvoice: 'Получить счет',
      notFoundTrips: "Бронирование не найдено",
      upcoming: "Предстоящие поездки",
      payToDriver: 'Оплата водителю',
      payWithCard: 'Оплачено картой',
      notificationButtons: {
        cancelBookingConfirm: "Да, отменить это бронирование",
        cancelBookingText: "Нет, оставить",
        refundInfo: "Если вы заплатили картой, вы получите деньги в течение 10 рабочих дней.",
        infoWithoutRefundNotification: "Вы отменяете менее чем за 8 часов до запланированного рейса. Оплата не будет возвращена.",
        editButton: "Изменить",
        cancel: "Отмена",
        booking: "Поездки",
        cancelBooking: {
          title: "Вы уверены, что хотите отменить это бронирование",
          message: "на %on% от %from% до %to%"
        },
        closeTitle: "Закрыть"
      },
      slider: {
        title: "Как прошла твоя поездка с %driverName%?",
        desc: "on %date% from %from% to %to%",
        content: "Оставьте нам свой отзыв, чтобы мы могли улучшить нашу работу!",
        addReview: "Добавить отзыв",
        closeReview: "Закрыть отзыв",
        textAreaPlaceholder: "Мы бы хотели узнать больше..."
      },
      summary: {
        newPrice: "Новая цена",
        changePrice: "Разница в цене",
        paySupl: "Заплатить",
        refund: "Возвращение денег",
        oldPrice: "Старая цена",
        changesSaved: "Ваши изменения были сохранены",
        payDriver: "Вы выбрали оплату водителю. Вы можете оплатить наличными (NOK) либо картой",
        buttonText: "OK"
      }
    },
    invoiceCheckbox: {
      company: "Оплачивает компания?",
      addInvoice: "Добавить информацию для счет-фактуры",
      canceledInfo: "Ваш запрос на выставление счета будет отменен",
      fillTheForm: {
        first: "Пожалуйста",
        last: " заполните всю форму"
      },
      issueInvoice: "Выставить счет на ",
      changeInfo: "Нужно изменить информацию в счете?"
    },
    flyOut: 'отправление',
    flyBack: 'прибытие',
    common: {
      success: "Сохранено",
      error: "Ошибка",
      terms: "Положения &amp;&nbsp;Условия",
      privacyPolicy: "Политика Конфиденциальности",
      logIn: "Войти",
      signUp: "Зарегистрироваться",
      bookNow: "Забронируйте сейчас",
      nothingInfo: "Здесь ничего нет",
      nothingMessage: "Ваше бронирование будет доступен здесь.",
      previous: "Предыдущее",
      loggedInError: "Вы должны войти в систему",
      loggedInMessage: "Приветствуем!",
      skipToLogin: "Перейти к Вход",
      somethingWrong: "К сожалению что-то пошло не так.",
      optional: 'необязательно',
      adults: 'Взрослые',
      travelersLabel: 'Pasażerowie',
      travelersInput: 'Pasażerowie',
      teenagers: 'Nastolatkowie 13-17',
      students: 'Studenci',
      seniors: 'Seniorzy',
      kids: 'Дети',
      under: 'до',
      step: 'шаг',
      next: 'далее',
      price: 'цена',
      currency: 'NOK',
      backToBooking: 'Вернуться к бронированию',
      backToLogin: 'Вернуться к Вход',
      backToProfile: 'Вернуться к профилю',
      ok: 'Ok',
      signUpWithEmail: 'Зарегистрируйтесь при помощи email',
      close: 'Закрыть',
      show: 'Показать',
      hide: 'Скрыть',
      back: 'Назад',
      save: 'Сохранить',
      inputs: {
        oldPassword: 'старый пароль',
        newPassword: 'новый пароль'
      },
      contact: {
        phone: "(+47) 96 70 11 03",
        phoneTitle: "Позвоните нам",
        email: "info@pksoslo.com",
        emailTitle: "Отправить нам email"
      }
    },
    calendar: {
      oneWay: 'В одну сторону',
      confirm: 'Ok'
    },
    bookingStep1: {
      mobile: {
        selectDate: 'Выбрать даты',
        selectDates: 'Выбрать даты',
        selectAirportLabel: 'Выбрать аэропорт',
        selectAirportTitle: 'Выбрать аэропорт',
      },
      headerChooseAirport: 'Выбрать аэропорт',
      header: 'Забронировать трансфер из аэропорта',
      whatFlight: 'На какой рейс вы собираетесь?',
      chooseAirport: {
        listEmpty: 'Не найдено ни одного аэропорта, попробуйте еще раз.',
        from: 'Выберите аэропорт из',
        to: 'Выберите аэропорт до',
      },
      chooseAirportPlaceholder: 'Выберите аэропорт ...',
      chooseAirportFrom: 'Откуда',
      chooseAirportTo: 'Куда',
      chooseSelectDate: 'Выбор даты',
      chooseSelectDatePlaceholder: 'Посмотреть календарь',
      letsGo: 'Поехали!',
      errors: {
        date: 'Необходима дата',
        busStop: 'Выбрать аэропорт',
        passengers: 'Выберите пассажиров'
      }
    },
    kidsSafety: {
      labels: {
        firstAge: '0-15 месяца',
        firstWeight: '0-13 кг',
        secondAge: '1-4 года',
        secondWeight: '9-18 кг',
        thirdAge: '4-12 лет',
        thirdWeight: '15-36 кг',
        fourthAge: '4+ года',
        fourthWeight: '15-36 кг',
      },
      title: 'Сиденье безопасности',
      tripWithCount: 'Вы путешесвуете с ',
      tripWithCountSufix: ' ребенок',
      typeOfSeatsQuestion: 'Какой тип сидений безопасности вам нужен?',
      safetyList: {
        chooseTitle: 'Вы должны выбрать ',
        chooseTitleSufix: ' из предложенных',
        items: {
          cradle: 'Автолюлька',
          seatWithSeatBelts: 'Кресло с ремнями',
          seatWithoutSeatBelts: 'Кресло без ремней',
          carSeatPad: 'Бустер',
          noNeedCarSeat: 'Мне не нужно сиденье '
        }
      }
    },
    bookingStep2: {
      chooseFlyOut: 'отправление',
      chooseFlyBack: 'прибытие',
      editKids: 'Редактировать сиденья безопасности',
      errors: {
        flight: {
          departure: 'Вы должны выбрать рейс',
          return: 'Вы должны выбрать рейс'
        }
      }
    },
    // map
    bookingStep3: {
      map: {
        backToSelectFlight: 'Вернуться к выбору рейса',
        addAddress: {
          first: 'Добавить ',
          second: ' другой ',
          third: ' обратный адрес'
        },
        removeReturnAddress: 'Удалить обратный адрес',
        addToFav: "Добавить в избранное"
      },
      address: {
        inputPlaceholder: 'Введите домашний адрес или выберите остановку'
      },
      favButton: 'Добавить в избранное',
      favSpotButton: 'Сохранить как:',
      spots: {
        home: 'Дом',
        work: 'Работа',
        other: 'Другое'
      },
      summary: {
        from: 'из',
        to: 'до',
        totalPrice: 'Итоговая цена:',
        smsInfoFirst: 'Мы отправим вам SMS со временем',
        smsInfoSecond: 'сбора за день до вылета.',
        tooltip: {
          button: 'Подробнее о сборе',
          departures: 'Отправление: Вы получите SMS за один день до отправления около 18.00 с точным временем приезда автобуса.',
          arrivals: 'Прибытие: Наш водитель будет ждать вас за пределами терминала.',
        }
      },
      errors: {
        postCode: 'Отсутствует почтовый индекс.',
        street: 'Пожалуйста, введите номер дома.',
        coords: 'Координаты не найдены для выбранного адреса.',
        addressNotFound: 'Адрес не найден.',
        connection: 'Не удалось установить соединение с сервером.', // general info when something is wrong with connection ...
        addressNotSupported: 'Сожалею! Мы не ездим по этому адресу.',
        selectAddress: 'Пожалуйста, выберите адрес.'
      }
    },
    //summary
    bookingStep4: {
      stepHeader: {
        title: 'Обзор бронирования',
        linkTitleAddressSelection: 'Вернуться к выбору адреса',
        linkTitleUserSelection: 'Вернуться к выбору пользователя'
      },
      summary: {
        selectCity: 'Выберите город',
        selectCityPlaceholder: 'Выберите город из списка',
        otherCity: 'Annen',
        title: 'Обзор ',
        totalPrice: 'Итоговая цена',
        bookNow: 'Забронировать ',
        payToDriver: 'Оплата водителю',
        payUsingCard: 'Оплатить с помощью карты'
      },
      address: {
        return: 'Вылет обратно',
        departure: 'Вылет: '
      },
      errors: {
        emptyCity: 'выберите город',
        payment: {
          emptyData: 'Отсутствуют данные. Завершите процесс бронирования, чтобы продолжить.',
          selectPaymentMethod: 'Выберите способ оплаты',
          cardDetails: 'Введите данные платежной карты',
          paymentFailed: 'Произошла ошибка при оплате'
        },

        map: {
          addressNotSupported: ' Сожалею! Мы не ездим под этот адрес',
          addressEmpty: 'Адрес не выбран',
          addressPostalCode: 'Сожалею! Мы не ездим на этот почтовый индекс',
          streetNumber: 'Введите номер дома',
          streetCoords: 'Координаты для выбранного адреса не найдены',
        }
      }
    },
    bookingStepFinal: {
      title: 'Спасибо, что выбрали нас',
      info: {
        first: 'Ваш бронирование было отправлено.',
        second: 'Вы можете редактировать свое бронирование бесплатно до 18.00 за день до вылета.',
        third: 'Если у вас есть какие-либо вопросы, не стесняйтесь обращаться к нам.'
      },
      confirm: 'Ok'

    },
    homepage: {
      title: 'Поездки в аэропорт стали проще',
      content: `Выберите рейс до либо из аэропорта Осло Сандефьорд Торп,
       а затем закажите автобус по телефону или на сайте.
       Мы заберем вас из дома, работы или аэропорта. За день до вылета вы получите
       SMS с подтверждением времени прибытия автобуса.
       Также мы позвоним вам за несколько минут до прибытия водителя.`
    },
    prices: {
      title: 'Цены за трансфер из аэропорта',
      content: 'Надежные трансферы Oslo Torp по доступным ценам'
    },
    help: {
      header: 'Помощь',
      question: 'Есть ли у вас какие-либо вопросы касательно наших услуг?',
      checkLink: 'Проверьте ссылки ниже или свяжитесь с нами.',
      officeWorks: 'Наш офис работает ежедневно с 08:00 до 21:00.',
      rightsReserved: '© 2019 Flyo AS. Все права защищены.'
    }
  },
  routes: {
    url: {
      booking: '/:locale/booking',
      kidsSafety: '/:locale/booking/kids-safety',
      flights: '/:locale/booking/flight',
      map: '/:locale/booking/map',
      userData: '/:locale/booking/user-data',
      confirmPhone: '/:locale/booking/confirm-phone',
      summary: '/:locale/booking/summary',
      confirmed: '/:locale/booking/confirmed',
      signup: '/:locale/signup',
      registrationStep1: '/:locale/registration-step-1',
      registrationStep2: '/:locale/registration-step-2',
      registrationStep3: '/:locale/registration-step-3',
      login: '/:locale/login',
      resetPassword: '/:locale/reset-password',
      dashboard: '/:locale/dashboard',
      dashboardEdit: '/:locale/dashboard/edit/:id',
      dashboardReservationPayment: '/:locale/dashboard/reservation-payment',
      help: '/:locale/help',
      accountTrips: '/:locale/account/my-trips',
      account: '/:locale/account',
      accountProfile: '/:locale/account/profile',
      accountCards: '/:locale/account/cards',
      accountPlaces: '/:locale/account/places',
      accountPlacesMap: '/:locale/account/map',
      accountInvoices: '/:locale/account/invoices',
      accountSettings: '/:locale/account/settings',

      home: '/ru',
      howItWorks: '/:locale/how-it-works',
      prices: '/:locale/pricing',
      hortenTorp: '/:locale/airport-shuttle-horten-torp',
      complaint: '/:locale/complaint',
      faq: '/:locale/faq',
      contact: '/:locale/contact',
      termsAndConditions: '/:locale/terms',
      privacyPolicy: '/:locale/privacy-policy',
    },
    name: {
    }
  },
  test: { test: "cześć" },
  errors: {
    notFound: {
      title: "404",
      content: "Oops! We could not find the site you were looking for."
    }
  }
}
